/**
 * @file Persistence helpers for one-time web-gallery tip popups.
 *
 * Reuses the same localStorage registry (`__WALDO_APP__.dismissedKeys`) that
 * DismissiblePersistent / useDismissiblePersistent use, so a tip keyed per
 * gallery fires only once per device.
 */

import store from 'store';

import { STORE_NAMESPACE } from '../../../components/global/DismissiblePersistent';

/**
 * Records that a tip has been shown for this key. Returns true only the first
 * time it's called for a given key, so the caller can fire the tip just once.
 *
 * @param {string} key - The unique storage key for the tip.
 * @returns {boolean} - True if this call claimed the first show; false if already shown.
 */
export const claimFirstTipShow = key => {
  const localStore = store.get(STORE_NAMESPACE) || {};
  const { dismissedKeys = [] } = localStore;

  if (dismissedKeys.includes(key)) {
    return false;
  }

  store.set(STORE_NAMESPACE, {
    ...localStore,
    dismissedKeys: [...dismissedKeys, key],
  });

  return true;
};
